import React, { useEffect, useState } from 'react';  // Import useState and useEffect
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import { resolveConfig } from './config-util.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppWrapper = () => {
    const [config, setConfig] = useState(null);

    useEffect(() => {
       setConfig(resolveConfig());
    }, []);

    if (!config) {
        return null;
    }

    return (
        <Auth0Provider
            domain={config.auth.domain}
            clientId={config.auth.client_id}
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: config.auth.audience,
                scope: "openid profile email read:users_app_metadata",
            }}
        >
            <Router>
                <Routes>
                    <Route path="/" element={<App />} />
                </Routes>
            </Router>
        </Auth0Provider>
    );
};

root.render(<AppWrapper />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
